import { Button, VStack } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputText } from "components/Atomos/Form/Elements/InputText";
import { FormComponentProps } from "models/loginForm";
import { ResetPasswordFormData, resetPasswordSchema } from "models/password-reset.model";
import { useState } from "react";
import { useForm } from "react-hook-form";

type ResetPasswordFormProps = FormComponentProps<ResetPasswordFormData>;

const ResetPasswordForm = ({
    onSuccess,
    onFailed
}: ResetPasswordFormProps) => {
    const { register, formState: { errors }, handleSubmit } = useForm<ResetPasswordFormData>({
        resolver: yupResolver(resetPasswordSchema)
    });

    const [submitting, setSubmitting] = useState(false);
    const handleSubmitClick = async (data: ResetPasswordFormData) => {
        try {
            setSubmitting(true);
            await onSuccess(data);
        } catch (err) {
            onFailed?.(err);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <VStack spacing={4} w="full" as="form" onSubmit={handleSubmit(handleSubmitClick)}>
            <InputText
                name="newPassword"
                label="Nova senha"
                register={register}
                type="password"
                error={errors?.newPassword}
            />
            <InputText
                name="newPasswordConfirmation"
                label="Confirmação da nova senha"
                register={register}
                type="password"
                error={errors?.newPasswordConfirmation}
            />
            <Button colorScheme="main" isFullWidth type="submit" isLoading={submitting}>Alterar</Button>
        </VStack>
    )
}
export default ResetPasswordForm